/*
* @描述: 商机详情页
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/24 15:23
*/
<template>
    <div class="public_container">
        <div class="returnNavBar">
            <ReturnNavBar :isAllFunctions="false" :isTitleNormal="true" title="返回"></ReturnNavBar>
            <div v-if="permission['project.edit']||hasDelPermission" class="returnNavBarRight">
                <i class="iconfont icon-gengduo1" @click="moreFunctionVisible = true"></i>
            </div>
        </div>
        <div v-loading="loading" class="detail_wrap_container">
            <div v-if="businessStage===-2" class="loser_reason_wrap">
                <span class="loser_title"><i class="iconfont icon-ku"></i> 输单原因：</span>
                <span class="loser_text" v-text="projectFormDetail.remarks"></span>
            </div>
            <div v-if="businessStage===-3" class="invalid_reason_wrap">
                <span class="loser_title"><i class="iconfont icon-wunai"></i> 无效原因：</span>
                <span class="loser_text" v-text="projectFormDetail.remarks"></span>
            </div>
            <div class="business_info_wrap">
                <div class="flex_js_wrap">
                    <div class="flex_wrap">
                        <i class="iconfont icon-shangji"></i>
                        <h3 v-if="projectFormDetail.name" v-text="projectFormDetail.name.value"></h3>
                    </div>
                    <el-link :underline="false" type="primary" @click="handleClickElaborateOrRetract">
                        {{ elaborateOrRetract ? '收起' : '展开' }} <i
                            :class="elaborateOrRetract?'icon-shangjiantou':'icon-xiajiantou'"
                            class="iconfont"></i>
                    </el-link>
                </div>
                <div class="custom_info_wrap">
                    <div class="custom_contact_field_wrap">
                        <PersonnelCard v-if="projectFormDetail.salesperson"
                                       :userId="projectFormDetail.salesperson.value[0]">
                            <template slot="container">
                                <img :src="projectFormDetail.salesperson.text[0].avatar || defaultImg" alt=""
                                     class="avatar">
                                <span class="name" v-text="projectFormDetail.salesperson.text[0].name"></span>
                            </template>
                        </PersonnelCard>
                    </div>
                    <span v-if="projectFormDetail.customer_id" class="company_name"
                          v-text="projectFormDetail.customer_id.text"></span>
                </div>
                <div v-if="elaborateOrRetract" class="detail_form_wrap">
                    <CustomFormDetailMobile v-if="dataLoaded"
                                            :field_list="formInfoList"
                                            :form_detail="projectFormDetail"
                                            :pk_id="project_id"/>
                </div>
            </div>
            <div class="business_tabs_wrap">
                <van-tabs v-model="tabActiveName"
                          animated
                          color="#2990ff"
                          sticky
                          swipeable
                          title-active-color="#2990ff">
                    <van-tab name="stage" title="商机阶段">
                        <div class="m_page_little_title">
                            <span class="title">阶段任务</span>
                        </div>
                    </van-tab>
                    <van-tab name="order" title="关联订单"></van-tab>
                    <van-tab name="work_order" title="关联工单"></van-tab>
                    <van-tab name="member" title="团队成员"></van-tab>
                    <van-tab name="follow_up" title="跟进动态"></van-tab>
                    <van-tab name="log" title="日志"></van-tab>
                </van-tabs>
            </div>
        </div>
        <van-overlay v-if="moreFunctionVisible"
                     :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                     :show="moreFunctionVisible"
                     z-index="1000"
                     @click="moreFunctionVisible = false">
            <div class="custom_radio_option_wrap">
                <ul class="radio_option_list">
                    <li v-if="permission['project.edit']"
                        class="radio_option_item"
                        @click="handleClickEditBusiness">编辑
                    </li>
                    <li v-if="projectFormDetail.approval_status===1&&permission['project.edit']"
                        class="radio_option_item"
                        @click="handleClickChangeThePerson">更换负责人
                    </li>
                    <li v-if="hasDelPermission"
                        class="radio_option_item"
                        @click="handleClickDelBusiness">删除
                    </li>
                </ul>
                <div class="cancel_btn" @click="moreFunctionVisible = false">取消</div>
            </div>
        </van-overlay>
        <addMember v-if="teamMembersAddVisible"
                   :dialogVisible.sync="teamMembersAddVisible"
                   :project_ids="[project_id]"
                   @refresh="getProjectMemberList"/>
    </div>
</template>
<script>
import {
    getFormFields,
    projectDetail,
    groupGetStageAndTask,
    stagePushInfoAutoSave,
    getAutoSaveStagePushInfo,
    stagePush,
    stageInfoUpdate,
    projectMemberList,
    projectMemberAuthEdit,
    projectMemberDel,
    projectGroupUpdateLogIsUnread,
    projectLogList,
    GetCustomerLogList,
    projectDel,
    projectQuotationListByProjectId,
    getOrderList,
    workOrderList
} from "@/api";
import CustomFormDetailMobile from "@/components/mComponents/CustomFormDetailMobile";
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import businessEdit from "./component/business_edit";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
// import followUpAdd from "./component/follow_up_add";
// import followUpDetail from "./component/follow_up_detail";
// import managementRecordAdd from "./component/management_record_add";
// import managementRecordDetail from "./component/management_record_detail";
// import quotationTemplate from "./component/quotation_template";
import addMember from "./component/add_member";
import changeThePerson from "./component/change_the_person";
import OrderAdd from "@/views/mobile/Order/component/order_add";
import {EventBus} from "@/utils/eventBus";
import {mapGetters} from "vuex";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc.vue";

export default {
    name: "BusinessDetail",
    data() {
        return {
            loading: false,
            userInfo: {},
            elaborateOrRetract: false,
            formInfoList: [],
            projectFormDetail: {},
            dataLoaded: false,
            projectStagesList: [],
            stageTaskFormShow: false,
            businessStage: 1,
            failureRemarksDialog: false,
            failureRemarks: '',
            invalidRemarksDialog: false,
            invalidRemarks: '',
            formValidateRes: false,
            relateQuotationList: [], // 关联报价单
            relateOrderList: [], // 关联订单
            relateWorkOrderList: [], // 关联工单
            teamMembersList: [], // 团队成员
            followUpDynamicsList: [], // 跟进动态
            logRecordList: [], // 日志
            popoverLoad: false,
            teamMembersAddVisible: false,
            teamMembersAddForm: {
                member: '',
                authorization: 'read_write'
            },
            teamMembersAddFormRules: {
                member: [
                    {required: true, message: '请选择成员', trigger: 'blur'}
                ]
            },
            addFollowUpVisible: false,
            addManagementRecordsVisible: false,
            followUpRecordsDetailVisible: false,
            managementRecordsDetailVisible: false,
            managementRecordsId: 0,
            recordsFilterForm: {
                type: '',
                dateRange: []
            },
            addQuotationDialogVisible: false,
            defaultImg: require('@/assets/images/default.jpg'),
            project_id: Number(this.$route.query.project_id),
            stageTaskDialogVisible: false,
            stageTaskFieldsList: [], // 阶段任务字段
            stageTaskFieldsFormDetail: {}, //阶段任务详情
            editBusinessDialogVisible: false,
            currentProjectStageId: 0, // 当前阶段id
            currentStageSort: 0, // 当前阶段序号
            currentStageData: {}, // 当前阶段数据
            currentStageTaskFieldList: [],//当前阶段任务字段
            currentStageTaskFormDetail: {},// 当前阶段任务详情
            isStagePush: false, //是否为推进
            nextStageId: 0, // 下一阶段id
            changeThePersonDialogVisible: false,
            logRecordsDetailVisible: false,
            logRecordsDetail: [],
            addOrderDialogVisible: false,
            project_data: {},
            permission: {},
            btnDisabled: false,
            moreFunctionVisible: false,
            tabActiveName: 'stage'
        }
    },
    components: {
        CustomFormDetailPc,
        ReturnNavBar,
        OrderAdd,
        CustomFormDetailMobile,
        CustomFormPc,
        businessEdit,
        PersonnelCard,
        // followUpAdd,
        // followUpDetail,
        // managementRecordAdd,
        // managementRecordDetail,
        // quotationTemplate,
        addMember,
        // changeThePerson,
    },
    computed: {
        ...mapGetters(['hasPermission']),
        hasDelPermission() {
            return this.hasPermission('project.del', 'customer', 'Project');
        },
    },
    created() {
        projectGroupUpdateLogIsUnread({
            project_id: this.project_id
        }).then(res => {
            if (res.data && res.data.isUnread) {
                const h = this.$createElement;
                this.$dialog.confirm({
                    title: '商机阶段发生变化',
                    message: '由于管理员更改了商机流程，该商机阶段发生变化，但原本填写的某些信息将会保留，可在日志中查看原阶段情况！',
                    confirmButtonColor: '#2990FF',
                }).then(() => {
                    this.isStagePush = false
                }).catch(() => {
                    this.isStagePush = false
                })
            }
        })
        this.getBusinessDetail()
    },
    mounted() {

    },
    methods: {
        // 展开/收起
        handleClickElaborateOrRetract() {
            this.elaborateOrRetract = !this.elaborateOrRetract
            if (this.elaborateOrRetract && this.formInfoList.length === 0) {
                this._getFromFields()
            }
        },

        //获取商机详情
        getBusinessDetail() {
            this.loading = true
            projectDetail({
                project_id: this.project_id,
            }).then(res => {
                if (res.code === 200) {
                    this.projectFormDetail = res.data
                    this.permission = res.data.permission
                    groupGetStageAndTask({
                        project_group_id: res.data.project_group_id
                    }).then(res => {
                        if (res.code === 200) {
                            this.projectStagesList = res.data || []
                            if (this.projectStagesList.length) {
                                if (this.projectFormDetail.project_stage.value > 0) {
                                    this.currentStageData = this.projectStagesList.find(item => item.project_stage_id === this.projectFormDetail.project_stage.value)
                                    this.currentProjectStageId = this.projectFormDetail.project_stage.value
                                    this.currentStageTaskFieldList = this.currentStageData.tasks
                                    this.currentStageSort = this.currentStageData.sort
                                    if (this.currentStageTaskFieldList.length) {
                                        getAutoSaveStagePushInfo({
                                            project_id: this.project_id,
                                            project_stage: this.projectFormDetail.project_stage.value,
                                        }).then(res => {
                                            if (res.code === 200) {
                                                this.currentStageTaskFieldList.forEach(field => {
                                                    this.$set(field, 'is_edit', true)
                                                    if (this.projectFormDetail.hasOwnProperty(field.field_key)) {
                                                        this.$set(this.currentStageTaskFormDetail, field.field_key, this.projectFormDetail[field.field_key])
                                                    }
                                                    if (res.data && res.data.hasOwnProperty(field.field_key)) {
                                                        const field_value = res.data[field.field_key]
                                                        if ((Array.isArray(field_value) && field_value.length) || ((typeof field_value === 'object' && !Array.isArray(field_value)) && (field_value.value !== '' || field_value.value !== undefined || field_value.value.length !== 0))) {
                                                            this.$set(this.currentStageTaskFormDetail, field.field_key, res.data[field.field_key])
                                                        }
                                                    }
                                                })
                                                this.stageTaskFormShow = true
                                            } else {

                                            }
                                        })
                                    }
                                } else {
                                    this.businessStage = this.projectFormDetail.project_stage.value
                                }
                            }
                        }
                        this.loading = false
                    })
                } else {

                    this.loading = false
                }
            })
        },

        // 获取表单字段
        _getFromFields() {
            getFormFields({
                field_form: 'projects'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data.filter(item => item.field_key !== 'name' && item.field_key !== 'salesperson' && item.field_key !== 'customer_id' && item.field_key !== 'project_stage')
                    this.dataLoaded = true
                } else {

                }
            }).catch(() => {
            })
        },

        //点击编辑商机
        handleClickEditBusiness() {
            this.editBusinessDialogVisible = true
        },

        //点击更换负责人
        handleClickChangeThePerson() {
            this.changeThePersonDialogVisible = true
        },

        //点击删除商机
        handleClickDelBusiness() {
            this.$msgbox({
                title: '确认删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                projectDel({
                    project_id: [this.project_id]
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('删除成功')
                        this.$router.replace({
                            name: 'Business'
                        })
                    } else {

                    }
                }).catch(() => {

                })
            }).catch(() => {

            })
        },

        //点击某个阶段
        handleClickStageItem(item) {
            this.currentStageSort = item.sort
            if (item.sort < this.currentStageData.sort) {
                this.stageTaskFormShow = false
                this.currentStageTaskFieldList = item.tasks
                this.currentStageTaskFormDetail = {}
                this.currentStageTaskFieldList.forEach(field => {
                    this.$set(this.currentStageTaskFormDetail, field.field_key, this.projectFormDetail[field.field_key])
                })
                this.$nextTick(() => {
                    this.stageTaskFormShow = true
                })
            } else if (item.sort === this.currentStageData.sort) {
                this.stageTaskFormShow = false
                this.currentStageTaskFieldList = item.tasks
                getAutoSaveStagePushInfo({
                    project_id: this.project_id,
                    project_stage: this.projectFormDetail.project_stage.value,
                }).then(res => {
                    if (res.code === 200) {
                        this.currentStageTaskFormDetail = res.data || {}
                        this.stageTaskFormShow = true
                    } else {

                    }
                })
            } else {
                this.projectStagesList.forEach((stage, stage_index) => {
                    if (stage.sort >= this.currentStageData.sort && stage.sort < item.sort && stage.tasks.length) {
                        const field = {
                            field_form: "projects",
                            field_key: stage.project_stage_id,
                            field_name: stage.name + '任务',
                            field_type: "form_module",
                            extend: {
                                is_form_show: true
                            },
                            sort: stage_index + 1,
                            _child: stage.tasks
                        }
                        this.stageTaskFieldsList.push(field)
                        field._child.forEach(child => {
                            if (this.projectFormDetail.hasOwnProperty(child.field_key)) {
                                this.$set(this.stageTaskFieldsFormDetail, child.field_key, this.projectFormDetail[child.field_key])
                            }
                            if (this.currentStageTaskFormDetail.hasOwnProperty(child.field_key)) {
                                const field_value = this.currentStageTaskFormDetail[child.field_key]
                                if ((Array.isArray(field_value) && field_value.length) || ((typeof field_value === 'object' && !Array.isArray(field_value)) && (field_value.value !== '' || field_value.value !== undefined || field_value.value.length !== 0))) {
                                    this.$set(this.stageTaskFieldsFormDetail, child.field_key, this.currentStageTaskFormDetail[child.field_key])
                                }
                            }
                        })
                    }
                })
                if (this.stageTaskFieldsList.length) {
                    this.stageTaskDialogVisible = true
                } else {
                    this.stageTaskFormShow = false
                    this.currentStageTaskFieldList = item.tasks
                    this.$nextTick(() => {
                        this.stageTaskFormShow = true
                    })
                }
            }
        },

        //阶段任务取消事件
        handleClickStageTaskDialogCancel() {
            this.stageTaskDialogVisible = false
            this.stageTaskFieldsList = []
        },

        //阶段任务确定事件
        handleClickStageTaskDialogConfirm() {
            this.$refs.stage_task_form.handleClickPublish()
        },

        //获取阶段任务表单数据
        submitTaskFormData(data) {
            this.btnDisabled = true
            stagePush({
                project_id: this.project_id,
                project_stage: this.projectStagesList.find(item => item.sort === this.currentStageSort).project_stage_id,
                ...data
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('推进成功')
                    this.stageTaskDialogVisible = false
                    this.stageTaskFormShow = false
                    this.getBusinessDetail()
                } else {

                }
                this.btnDisabled = false
            })
        },

        // 点击推进下一阶段
        handleClickAdvanceNextStage() {
            this.isStagePush = true
            this.$refs.now_stage_task_detail_form.handleClickPublish()
            this.nextStageId = this.projectStagesList.find(item => item.sort > this.currentStageData.sort).project_stage_id
        },

        //点击赢单
        handleClickBusinessTriumph() {
            stagePush({
                project_id: this.project_id,
                project_stage: -1,
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('操作成功')
                    this.currentStageTaskFieldList = []
                    this.stageTaskFormShow = false
                    this.getBusinessDetail()
                } else {

                }
            })
        },

        // 点击输单
        handleClickBusinessFailure() {
            this.failureRemarksDialog = true
        },

        //输单取消
        handleClickFailureReasonCancel() {
            this.failureRemarksDialog = false
            this.failureRemarks = ''
            this.btnDisabled = false
        },

        // 输单确定
        handleClickFailureReasonConfirm() {
            if (this.failureRemarks.trim() === '') return this.$toast.fail('请输入输单原因！')
            this.btnDisabled = true
            stagePush({
                project_id: this.project_id,
                project_stage: -2,
                remarks: this.failureRemarks
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('操作成功')
                    this.currentStageTaskFieldList = []
                    this.stageTaskFormShow = false
                    this.btnDisabled = false
                    this.handleClickFailureReasonCancel()
                    this.getBusinessDetail()
                } else {

                }
            })
        },

        // 点击无效商机
        handleClickBusinessInvalid() {
            this.invalidRemarksDialog = true
        },

        // 无效商机取消
        handleClickInvalidReasonCancel() {
            this.invalidRemarksDialog = false
            this.invalidRemarks = ''
            this.btnDisabled = false
        },

        // 无效商机确定
        handleClickInvalidReasonConfirm() {
            if (this.invalidRemarks.trim() === '') return this.$toast.fail('请输入无效原因！')
            this.btnDisabled = true
            stagePush({
                project_id: this.project_id,
                project_stage: -3,
                remarks: this.invalidRemarks
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('操作成功')
                    this.currentStageTaskFieldList = []
                    this.stageTaskFormShow = false
                    this.btnDisabled = false
                    this.handleClickInvalidReasonCancel()
                    this.getBusinessDetail()
                } else {

                }
            })
        },

        //获取商机阶段表单数据
        submitDetailFormData(data) {
            this.btnDisabled = true
            this.formValidateRes = Object.keys(data).length > 0
            if (this.formValidateRes) {
                if (this.isStagePush) {
                    this.isStagePush = false
                    stagePush({
                        project_id: this.project_id,
                        project_stage: this.nextStageId,
                        ...data
                    }).then(res => {
                        if (res.code === 200) {
                            this.$toast.success('推进成功！')
                            this.stageTaskFormShow = false
                            this.getBusinessDetail()
                            this.nextStageId = 0
                        } else {

                        }
                        this.btnDisabled = false
                    })
                } else {
                    if (this.currentStageSort < this.currentStageData.sort) {
                        stageInfoUpdate({
                            project_id: this.project_id,
                            ...data
                        }).then(res => {
                            if (res.code === 200) {
                                this.$toast.success('修改成功！')
                            } else {

                            }
                            this.btnDisabled = false
                        })
                    } else {
                        stagePushInfoAutoSave({
                            project_id: this.project_id,
                            project_stage: this.currentStageData.project_stage_id,
                            data
                        }).then(res => {
                            if (res.code === 200) {
                                this.$toast.success('保存成功！')
                            } else {

                            }
                            this.btnDisabled = false
                        })
                    }
                    this.formValidateRes = false
                }
            } else {
                if (this.isStagePush) {
                    this.$dialog.confirm({
                        title: '推进至下一阶段',
                        message: '当前阶段有任务待完成，无法直接推进！',
                        confirmButtonColor: '#2990ff'
                    }).then(() => {
                        this.isStagePush = false
                        this.btnDisabled = false
                    }).catch(() => {
                        this.isStagePush = false
                    })
                }
            }
        },

        //点击关联商机报价单
        handleClickRelateQuotation() {
            this.popoverLoad = true
            projectQuotationListByProjectId({
                project_id: this.project_id
            }).then(res => {
                this.relateQuotationList = res.data
                this.popoverLoad = false
            })
        },

        // 点击查看报价单详情
        handleClickQuotationDetail(item) {
            this.$router.push({
                name: "QuotationDetails",
                params: {
                    isPush: true,
                },
                query: {
                    project_quotation_id: item.project_quotation_id,
                    name: item.quotation_num,
                },
            })
        },

        //点击新建报价单
        handleClickAddNewQuotation() {
            this.addQuotationDialogVisible = true
            const project_data = {
                project_id: this.project_id,
                project_name: this.projectFormDetail.name,
                customer_id: this.projectFormDetail.customer_id,
                contact_id: {
                    value: this.projectFormDetail.contact_id.value,
                    text: [this.projectFormDetail.contact_id.text && this.projectFormDetail.contact_id.text.length ? this.projectFormDetail.contact_id.text[0].name : ''],
                },
                contact_phone: {
                    value: this.projectFormDetail.contact_id.text && this.projectFormDetail.contact_id.text.length ? this.projectFormDetail.contact_id.text[0].phone : ''
                }
            }
            this.$store.dispatch('saveRelateProjectData', project_data)
            EventBus.$on('quotationUpdated', this.handleClickRelateQuotation);
        },

        //点击关联订单
        handleClickRelateOrder() {
            this.popoverLoad = true
            getOrderList({
                project_id: this.project_id,
                page: 1,
                pageSize: 100,
                status: 0
            }).then(res => {
                if (res.code === 200) {
                    this.relateOrderList = res.data.data
                    this.popoverLoad = false
                }
            })
        },

        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id,
                    name: row.order_num,
                },
            });
        },

        // 新建订单
        handleClickAddOrder() {
            this.project_data = {
                project_id: this.project_id,
                project_name: this.project_name,
            }
            this.addOrderDialogVisible = true
        },

        //点击关联工单
        handleClickRelateWorkOrder() {
            this.popoverLoad = true
            workOrderList({
                project_id: this.project_id,
                page: 1,
                pageSize: 100
            }).then(res => {
                this.relateWorkOrderList = res.data.data
                this.popoverLoad = false
            })
        },

        //点击工单详情
        handleClickWorkOrderDetail(row) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.workorder_num,
                },
            });
        },

        //点击团队成员
        handleClickTeamMember() {
            if (this.teamMembersList.length === 0) {
                this.popoverLoad = true
                this.getProjectMemberList()
            }
        },

        //获取团队成员列表
        getProjectMemberList() {
            projectMemberList({
                project_id: this.project_id
            }).then(res => {
                if (res.code === 200) {
                    this.popoverLoad = false
                    this.teamMembersList = res.data
                } else {
                    this.popoverLoad = false
                }
            })
        },

        //点击添加团队成员
        handleClickAddTeamMember() {
            this.teamMembersAddVisible = true
        },

        //点击删除团队成员
        handleClickDeleteTeamMember(item) {
            this.$dialog.confirm({
                title: '删除团队成员',
                message: '确定删除该成员吗？',
                confirmButtonColor: '#E44144'
            }).then(() => {
                projectMemberDel({
                    project_id: this.project_id,
                    member_uid: item.member_uid
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('删除成功')
                        this.getProjectMemberList()
                    } else {

                    }
                })
            }).catch(() => {

            })
        },

        //团队成员权限编辑
        handleMemberAuthChange(item) {
            projectMemberAuthEdit({
                project_id: this.project_id,
                member_uid: item.member_uid,
                auth: item.auth
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('修改成功')
                    this.getProjectMemberList()
                } else {

                }
            })
        },

        //点击跟进动态
        handleClickFollowUpDynamics() {
            if (this.followUpDynamicsList.length === 0) {
                this.popoverLoad = true
                GetCustomerLogList({
                    project_id: this.project_id,
                    dateRange: this.recordsFilterForm.dateRange ? this.recordsFilterForm.dateRange.join(' - ') : '',
                    type: this.recordsFilterForm.type,
                    keyword: '',
                    modelSwitch: {}
                }).then(res => {
                    if (res.code === 200) {
                        this.followUpDynamicsList = res.data.list
                        this.popoverLoad = false
                    } else {

                        this.popoverLoad = false
                    }
                })
            }
        },

        //筛选事件
        handleRecordsFilterChange() {
            this.$refs.records_filter_popper.doClose()
            this.popoverLoad = true
            GetCustomerLogList({
                project_id: this.project_id,
                dateRange: this.recordsFilterForm.dateRange ? this.recordsFilterForm.dateRange.join(' - ') : '',
                type: this.recordsFilterForm.type,
                keyword: '',
                modelSwitch: {}
            }).then(res => {
                if (res.code === 200) {
                    this.followUpDynamicsList = res.data.list
                    this.popoverLoad = false
                } else {

                    this.popoverLoad = false
                }
            })
        },

        //点击添加跟进记录
        handleClickAddFollowUp() {
            this.addFollowUpVisible = true
        },

        //点击新增管理记录
        handleClickAddManagementRecords() {
            this.addManagementRecordsVisible = true
        },

        //点击跟进记录详情
        handleClickManagementRecordsDetail(item) {
            this.managementRecordsId = item.relate_id
            if (item.type === 'follow_up_project') {
                this.followUpRecordsDetailVisible = true
            } else {
                this.managementRecordsDetailVisible = true
            }
        },

        //点击日志
        handleClickLogRecord() {
            this.popoverLoad = true
            projectLogList({
                project_id: this.project_id
            }).then(res => {
                if (res.code === 200) {
                    this.logRecordList = res.data.data
                } else {

                }
            })
            this.popoverLoad = false
        },

        //显示原商机阶段详情
        handleClickLogRecordsDetail(item) {
            this.logRecordsDetail = item.content.details
            this.logRecordsDetail.forEach(log => {
                log.form_detail = {}
                log.tasks.forEach(field => {
                    this.$set(log.form_detail, field.field_key, field.field_value)
                })
            })
            this.logRecordsDetailVisible = true
        },

        handleClickLogRecordsDetailClose() {
            this.logRecordsDetailVisible = false
            this.logRecordsDetail = []
        }
    },
    beforeDestroy() {
        EventBus.$off('quotationUpdated', this.handleClickRelateQuotation);
    },
}
</script>
<style lang="scss" scoped>
.detail_wrap_container {
    padding-top: 10px;
    background-color: #F7F8FA;

    .loser_reason_wrap {
        padding: 8px 16px;
        line-height: 22px;
        border-radius: 4px;
        background: #FBE1E1;

        .loser_title {
            color: #E44144;
        }

        .loser_text {
            color: #333333;
        }
    }

    .invalid_reason_wrap {
        padding: 8px 16px;
        line-height: 22px;
        border-radius: 4px;
        background: #E8E8E8;

        .loser_title {
            color: #333333;
        }

        .loser_text {
            color: #333333;
        }
    }

    .business_info_wrap {
        padding: 12px 12px 0;
        background-color: #FFFFFF;
        margin-bottom: 10px;

        .custom_info_wrap {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 16px 0 10px;

            .company_name {
                line-height: 22px;
                color: #666666;
            }
        }

        .detail_form_wrap {
            border-top: 1px solid #E8E8E8;
            padding-top: 10px;
        }
    }

    .business_tabs_wrap{
        background-color: #FFFFFF;
    }
}
</style>